import '../../App.css';
import React, {useContext, Suspense} from "react";
import AuthContext from "../../contexts/AuthContext";
import {useTranslation} from "react-i18next";
import FallbackLoader from "../FallbackLoader";
import {UserRole} from "../../models";
import S3FilesComponent from "../S3FilesComponent";
import PageHeader from "../PageHeader/PageHeader";

//const S3FilesComponent = lazy(() =>import("../S3FilesComponent"));

const bucketName = process.env.REACT_APP_ENV + "-smp-data";
const destFolder = "import/sensor-data/";

function WatermeterImport() {
    const [t] = useTranslation();
    const userContext = useContext(AuthContext);

    if (userContext.userInfoFromDB && [UserRole.ADMIN, UserRole.SUPER_ADMIN].includes(userContext.userInfoFromDB?.role)) {
        return (
            <div className="WatermeterImport">
                <PageHeader headerText={t('watermeterimport.header')} />
                <Suspense fallback={
                    <FallbackLoader />
                }>
                    <S3FilesComponent
                        uploadBtnText={t('watermeterimport.uploadBtnText')}
                        bucketName={bucketName}
                        destFolder={destFolder}
                        allowedFileExtensions={['.csv']}
                        type={"CSV"}
                    />
                </Suspense>
            </div>
        );
    } else {
        return null;
    }
}

export default WatermeterImport;
